const fullWidthCarousel = {
  item: 'basis-full',
}
const cottageCarousel = {
  container:
    'relative w-full flex lg:grid lg:grid-cols-12 lg:gap-x-4 overflow-x-auto snap-x snap-mandatory scroll-smooth gap-4 px-4 py-1 lg:px-0 lg:overflow-x-visible',
  item: 'basis-auto flex-1 lg:block lg:col-span-3',
}
const imagesCarousel = {
  container:
    'relative w-full flex lg:grid lg:grid-cols-10 lg:gap-x-4 overflow-x-auto snap-x snap-mandatory scroll-smooth gap-4 px-4 py-1 lg:px-0 lg:overflow-x-visible no-scrollbar',
  item: 'flex snap-center flex-1 lg:block lg:col-span-2',
}
export { cottageCarousel, fullWidthCarousel, imagesCarousel }
